import { CellItem } from '../../components/core/DataTable/dataTable.types';
export interface Dashboard extends CellItem {
  machine: string;
  dataId: string;
  dateFrom: string;
  dateTo: string;
  aggregation: string;
}
export interface DashboardOfAsset extends CellItem {
  assetId: number;
  assetName: string;
  id: number;
  name: string;
  type: DashboardTypes;
  url: string;
}

export enum DashboardTypes {
  MAIN_DASHBOARD = 'MainDashboard',
  EXTERNAL_URL = 'ExternalUrl',
  GRAFANA = 'Grafana',
  OPC_DASHBOARD = 'OpcDashboard',
}

// *** Forms ***
export interface DashboardInputs {
  machine: string;
  dataId: string;
  dateFrom: string;
  dateTo: string;
  aggregation: string;
}

export interface CounterQtyValues {
  time: string;
  value: number;
}
export interface CounterQtyArrayData {
  dataId: string;
  values: CounterQtyValues[];
}
export interface CounterQtyData {
  data: CounterQtyArrayData[];
  machine: string;
}

// *** Requests ***
export interface CounterQtyFilterByDateRequest {
  machine: string;
  dataId?: string;
  dateFrom: string;
  dateTo?: string;
  aggregation?: string;
}

export interface CounterQtyFilterByRelativeRequest {
  machine: string;
  start: string;
  dataId?: string;
  stop?: string;
  aggregation?: string;
}

export interface DashboardHistoryInputs {
  dateFrom: string;
  dateTo: string;
  interval: string;
}
